import { template as template_bf003e3789684a89a13625c8b7ca8d25 } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import Dropdown from 'ember-simplepractice/components/spds/action/button/dropdown';
import styles from './locale-switcher.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import t from 'ember-intl/helpers/t';
export default class LocaleSwitcher extends Component {
    @service
    localeManager;
    handleLocaleChange = async (event)=>{
        const selectedLocale = event.target.dataset.value;
        const previousLocale = this.localeManager.currentLocale;
        // Only proceed if locale actually changed
        if (selectedLocale !== previousLocale) {
            this.localeManager.setLocale(selectedLocale);
        }
    };
    static{
        template_bf003e3789684a89a13625c8b7ca8d25(`
    <Dropdown
      @buttonType="ghost"
      class={{styles.locale-select}}
      @onItemClick={{this.handleLocaleChange}}
      data-test-locale-switcher
      aria-label={{t "site.localeSwitcher.ariaLabel" language=this.localeManager.currentLocaleName}}
      ...attributes
    >
      <:trigger>
        {{svgJar "globe"}}
        <span class={{styles.locale-text}}>{{this.localeManager.currentLocaleName}}</span>
      </:trigger>
      <:menu as |menu|>
        {{#each this.localeManager.availableLocales as |locale|}}
          <menu.Item @value={{locale.code}} data-test-locale-option={{locale.code}}>
            {{locale.name}}
          </menu.Item>
        {{/each}}
      </:menu>
    </Dropdown>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
